import { render, staticRenderFns } from "./InviteRewardConfig.vue?vue&type=template&id=7a288c54&scoped=true"
import script from "./InviteRewardConfig.vue?vue&type=script&lang=js"
export * from "./InviteRewardConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a288c54",
  null
  
)

export default component.exports